import moment from "moment";
import _ from "lodash";

export function filterTeeTimeData(props, showGolfIrelandRates = false) {
  if (props) {
    const allowedTeeTimes = props?.filter((item) => {
      // Normalize restrictions into an array regardless of incoming shape
      let restrictions = item?.restrictions;
      if (restrictions == null) {
        restrictions = [];
      } else if (!Array.isArray(restrictions)) {
        // If it's a string or single object, wrap it into an array
        restrictions = [restrictions];
      }

      if (restrictions.length === 0) {
        return true;
      }

      const normalizedList = restrictions.map((r) =>
        String(r || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim()
      );

      const hasVisitorOnlineRestriction = normalizedList.some((normalized) =>
        normalized.includes("visitor online") ||
        (normalized.includes("visitor") && normalized.includes("online"))
      );

      const hasGolfIrelandRestriction = normalizedList.some((normalized) =>
        normalized.includes("golf ireland")
      );

      if (showGolfIrelandRates) {
        return !hasGolfIrelandRestriction;
      }
      return !hasVisitorOnlineRestriction;
    });

    const unique = allowedTeeTimes?.filter((obj, index) => {
      return (
        index ===
        allowedTeeTimes?.findIndex(
          (o) =>
            obj?.id === o?.id &&
            obj?.course === o?.course &&
            o?.time === obj?.time
        )
      );
    });
    let groupWithCourse = unique.reduce(function (r, a) {
      r[a?.course] = r[a?.course] || [];
      r[a?.course].push(a);
      return r;
    }, Object.create(null));

    const sortWithCourseName = Object.keys(groupWithCourse)
      .sort()
      .reduce((obj, key) => {
        obj[key] = groupWithCourse[key];
        return obj;
      }, {});

    let allCourse = Object.values(sortWithCourseName);

    let timeFilter = [];
    // allCourse?.map((item) => {
    //   let filterForMorning = _.filter(item, function (e) {
    //     return moment(e?.time).format("H") < 12;
    //   });
    //   let filterForEvening = _.filter(item, function (e) {
    //     return moment(e?.time).format("H") > 11;
    //   });
    //   let timeData = [
    //     {
    //       type: "Morning",
    //       courseName:
    //         filterForMorning.length > 0 ? filterForMorning[0].course : "",
    //       data: filterForMorning,
    //     },
    //     {
    //       type: "Afternoon",
    //       courseName:
    //         filterForEvening.length > 0 ? filterForEvening[0].course : "",
    //       data: filterForEvening,
    //     },
    //   ];
    //   timeFilter.push(timeData);
    // });
    allCourse?.forEach((item) => {
      let filterForMorning = _.filter(item, function (e) {
        return moment(e?.time).format("H") < 12;
      });
      let filterForEvening = _.filter(item, function (e) {
        return moment(e?.time).format("H") > 11;
      });
      let timeData = [
        {
          type: "Morning",
          courseName:
            filterForMorning.length > 0 ? filterForMorning[0].course : "",
          data: filterForMorning,
        },
        {
          type: "Afternoon",
          courseName:
            filterForEvening.length > 0 ? filterForEvening[0].course : "",
          data: filterForEvening,
        },
      ];
      timeFilter.push(timeData);
    });
    return timeFilter.filter((courseSlots) =>
      courseSlots?.some((slot) => Array.isArray(slot?.data) && slot?.data.length > 0)
    );
  } else {
    return [];
  }
}
